import TabMaster from "#core/components/tab/TabMaster"
import { Box, Button, Typography } from "@mui/material"
import { Fragment, useCallback, useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EvaluationCompetency } from "../EvaluationCompetency"
import { EvaluationQuestionsFooter } from "./EvaluationQuestionsFooter"
import { EvaluationQuestionsHeader } from "./EvaluationQuestionsHeader"
import { UseHasPermission } from "#hooks/useHasPermission"
import PERMISOS from "#constants/perfiles"

export const EvaluationQuestions = ({
	questionsData,
	values,
	setValues,
	perfilPuesto,
	noComment,
}) => {
	useEffect(() => {
		if (Object.keys(values).length > 0) return
		for (let q of questionsData) {
			const questions = { name: q.name }
			for (let question of q.questions) {
				questions[question.id] = null
			}
			setValues((vals) => ({
				...vals,
				[q.competencia]: { ...questions, observation: "" },
			}))
		}
		console.log("🚀 ~ useCompetencyData ~ questions:", questionsData)
	}, [questionsData, setValues, values])

	const [selectedType, setSelectedType] = useState(questionsData?.[0]?.competencia)

	const averageCompetency = useMemo(() => {
		let questions = { ...values?.[selectedType] }

		if ("observation" in questions) {
			delete questions.observation
			delete questions.name
		}
		if ("name" in questions) {
			delete questions.name
		}
		const keys = Object.keys(questions)
		if (keys?.length === 0) return 0
		let questionCount = 0
		const sum = Object.values(questions).reduce((acc, q) => {
			if (q) questionCount++
			return acc + q
		}, 0)
		return (sum / (questionCount || 1)).toFixed(2)
	}, [values, selectedType])

	const questionRating = useCallback(
		(id) => {
			const setRating = (rating) => {
				setValues((values) => ({
					...values,
					[selectedType]: { ...values?.[selectedType], [id]: rating },
				}))
			}
			const rating = values?.[selectedType]?.[id]
			return { rating, setRating }
		},
		[values, selectedType, setValues],
	)

	const competencyObservation = useCallback(
		(id) => {
			const setObservation = (observation) => {
				setValues((values) => ({
					...values,
					[selectedType]: {
						...values?.[selectedType],
						observation,
					},
				}))
			}
			const observation = values?.[selectedType]?.["observation"]
			return { observation, setObservation }
		},
		[values, selectedType, setValues],
	)

	const listTab = useMemo(
		() =>
			questionsData.map((q) => ({
				id: q.competencia,
				label: q.name,
				content: (
					<Fragment key={`tab-${q.name}`}>
						<EvaluationCompetency
							key={`questionary-${q.name}`}
							questions={q?.questions || []}
							questionRating={questionRating}
						/>
						<EvaluationQuestionsFooter
							{...{
								...competencyObservation(),
								averageCompetency,
								type: q.competencia,
								noComment,
							}}
						/>
					</Fragment>
				),
			})),
		[questionsData, questionRating, noComment, competencyObservation, averageCompetency],
	)

	if (!questionsData.length)
		return <EvaluationCompetenciesNotFound perfilPuesto={perfilPuesto} />

	return (
		<Box>
			<Box p={2}>
				<EvaluationQuestionsHeader
					questionsData={questionsData}
					selected={selectedType}
					{...{ answer: values, averageCompetency }}
				/>
			</Box>
			<TabMaster
				listTabs={listTab}
				selectedTab={selectedType}
				setSelectedTab={setSelectedType}
			/>
		</Box>
	)
}

export const EvaluationCompetenciesNotFound = ({ perfilPuesto }) => {
	const navigate = useNavigate()
	const isRh = UseHasPermission(PERMISOS.RH)
	if (!isRh)
		return (
			<Box sx={{ textAlign: "center", p: 2 }}>
				<Typography variant="h5">No hay Categorías disponibles</Typography>
				<Typography variant="h5">Por favor comunicado al equipo de RH</Typography>
			</Box>
		)
	return (
		<Box sx={{ textAlign: "center", p: 2 }}>
			<Typography variant="h5">No hay Categorías disponibles</Typography>
			<Button sx={{ mt: 2 }} onClick={() => navigate(`../perfil-puesto/${perfilPuesto}`)}>
				Ir al perfil de puesto
			</Button>
		</Box>
	)
}
